module.exports = {
	"permanent": "Permanente",
	"buttons": {
		"cancel": "Annulla",
		"close": "Chiudi",
		"copy": "Copia",
		"copyFile": "Copia file",
		"copyToClipboard": "Copia negli appunti",
		"create": "Crea",
		"delete": "Elimina",
		"download": "Scarica",
		"info": "Informazioni",
		"more": "Altro",
		"move": "Sposta",
		"moveFile": "Sposta file",
		"new": "Nuovo",
		"next": "Successivo",
		"ok": "OK",
		"replace": "Sostituisci",
		"previous": "Precedente",
		"rename": "Rinomina",
		"reportIssue": "Segnala un problema",
		"save": "Salva",
		"search": "Cerca",
		"select": "Seleziona",
		"share": "Condividi",
		"publish": "Publica",
		"selectMultiple": "Seleziona molteplici",
		"schedule": "Programma",
		"switchView": "Cambia vista",
		"toggleSidebar": "Mostra/nascondi la barra laterale",
		"update": "Aggiorna",
		"upload": "Carica",
		"permalink": "Ottieni link permanente"
	},
	"success": {
		"linkCopied": "Link copiato!"
	},
	"errors": {
		"forbidden": "Spiecente, sembra che tu non abbia i permessi per accedere a questa pagina.",
		"internal": "Qualcosa è andato veramente male.",
		"notFound": "Questo percorso non può essere raggiunto."
	},
	"files": {
		"folders": "Cartelle",
		"files": "Files",
		"body": "Contenuto",
		"clear": "Cancella",
		"closePreview": "Chiudi anteprima",
		"home": "Home",
		"lastModified": "Ultima modifica",
		"loading": "Caricamento...",
		"lonely": "Ci si sente soli qui...",
		"metadata": "Metadata",
		"multipleSelectionEnabled": "Selezione multipla attivata",
		"name": "Nome",
		"size": "Grandezza",
		"sortByName": "Ordina per nome",
		"sortBySize": "Ordina per dimensione",
		"sortByLastModified": "Ordina per ultima modifica"
	},
	"help": {
		"click": "seleziona un file o una cartella",
		"ctrl": {
			"click": "seleziona più file o cartelle",
			"f": "apre la barra di ricerca",
			"s": "salva un file o scarica la cartella in cui ci si trova"
		},
		"del": "elimina gli elementi selezionati",
		"doubleClick": "apre un file o una cartella",
		"esc": "annulla la selezione e/o chiude la finestra aperta",
		"f1": "questo pannello",
		"f2": "rinomina un file",
		"help": "Aiuto"
	},
	"login": {
		"password": "Password",
		"submit": "Entra",
		"username": "Nome utente",
		"wrongCredentials": "Credenziali errate"
	},
	"prompts": {
		"copy": "Copia",
		"copyMessage": "Seleziona la cartella in cui copiare i file:",
		"currentlyNavigating": "Attualmente navigando su:",
		"deleteMessageMultiple": "Sei sicuro di voler eliminare {count} file(s)?",
		"deleteMessageSingle": "Sei sicuro di voler eliminare questo file/cartella?",
		"deleteTitle": "Elimina",
		"displayName": "Nome Mostrato:",
		"download": "Scarica files",
		"downloadMessage": "Seleziona il formato che vuoi scaricare.",
		"error": "Qualcosa è andato per il verso storto",
		"fileInfo": "Informazioni sul file",
		"filesSelected": "{count} file selezionati.",
		"lastModified": "Ultima modifica",
		"move": "Sposta",
		"moveMessage": "Seleziona la nuova posizione per i tuoi file e/o cartella/e:",
		"newDir": "Nuova cartella",
		"newDirMessage": "Scrivi il nome della nuova cartella.",
		"newFile": "Nuovo file",
		"newFileMessage": "Scrivi il nome del nuovo file.",
		"numberDirs": "Numero di cartelle",
		"numberFiles": "Numero di files",
		"replace": "Sostituisci",
		"replaceMessage": "Uno dei file che stai cercando di caricare sta generando un conflitto per via del suo nome. Desideri sostituire il file già esistente?\n",
		"rename": "Rinomina",
		"renameMessage": "Inserisci un nuovo nome per",
		"show": "Mostra",
		"size": "Grandezza",
		"schedule": "Pianifica",
		"scheduleMessage": "Seleziona data e ora per programmare la pubbilicazione di questo post",
		"newArchetype": "Crea un nuovo post basato su un modello. Il tuo file verrà creato nella cartella."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Amministratore",
		"allowCommands": "Esegui comandi",
		"allowEdit": "Modifica, rinomina ed elimina file o cartelle",
		"allowNew": "Crea nuovi files o cartelle",
		"allowPublish": "Pubblica nuovi post e pagine",
		"avoidChanges": "(lascia vuoto per evitare cambiamenti)",
		"changePassword": "Modifica password",
		"commands": "Comandi",
		"commandsHelp": "Qui è possibile impostare i comandi che vengono eseguiti negli eventi denominati. È possibile  scrovere un comando per riga. Se l'evento è corretato ad un file, come ad esempio prima e dopo un salvataggio, la variabile d'ambiente \"FILE\" sarà disponibile per l'uso e conterrà il percorso al file.\n",
		"commandsUpdated": "Comandi aggiornati!",
		"customStylesheet": "Folgio di stile personalizzato",
		"examples": "Esempi",
		"globalSettings": "Impostazioni Globali",
		"language": "Lingua",
		"lockPassword": "Impedisci all'utente di modificare la password",
		"newPassword": "La tua nuova password",
		"newPasswordConfirm": "Conferma la password",
		"newUser": "Nuovo utente",
		"password": "Password",
		"passwordUpdated": "Password aggiornata!",
		"permissions": "Permessi",
		"permissionsHelp": "È possibile impostare l'utente come amministratore o scegliere i permessi singolarmente. Se si seleziona \"Amministratore\", tutte le altre opzioni saranno automaticamente assegnate. La gestione degli utenti rimane un privilegio di un amministratore.\n",
		"profileSettings": "Impostazioni del profilo",
		"ruleExample1": "Impedisci l'accesso a qualsiasi file avente come prefisso un punto\n (ad esempio .git, .gitignore) presente in ogni cartella.\n",
		"ruleExample2": "blocca l'accesso al file denominato Caddyfile nella radice del campo di applicazione.",
		"rules": "Regole",
		"rulesHelp1": "Qui è possibile definire una serie di regole e permessi per questo specifico utente. I file bloccati non appariranno negli elenchi e non saranno accessibili dagli utenti. all'utente. Sia regex che i percorsi relativi all'ambito di applicazione degli utenti sono supportati.\n",
		"rulesHelp2": "Ogni regola deve essere inserita in una riga diversa e deve iniziare  con la parola chiave {0} or {1}. Quindi si deve scrivere {2} se si utilizza un'espressione regolare e quindi l'espressione o il percorso.\n",
		"scope": "Scopo",
		"settingsUpdated": "Impostazioni aggiornate!",
		"user": "Utente",
		"userCommands": "Comandi",
		"userCommandsHelp": "Una lista separata dal spazi con i comandi disponibili per questo utente. Example:\n",
		"userCreated": "Utente creato!",
		"userDeleted": "Utente eliminato!",
		"userManagement": "Gestione degli utenti",
		"username": "Nome utente",
		"users": "Utenti",
		"userUpdated": "Utente aggiornato!"
	},
	"sidebar": {
		"help": "Aiuto",
		"logout": "Esci",
		"myFiles": "I miei file",
		"newFile": "Nuovo file",
		"newFolder": "Nuova cartella",
		"settings": "Impostazioni",
		"siteSettings": "Impostaizoni del sito",
		"hugoNew": "Hugo New",
		"preview": "Anteprima"
	},
	"search": {
		"images": "Immagini",
		"music": "Musica",
		"notSupportedCommand": "Questo no nè un comando supportato.",
		"pdf": "PDF",
		"pressToExecute": "Premi invio per eseguire.",
		"pressToSearch": "Permi invio per cercare.",
		"search": "Cerca...",
		"searchOrCommand": "Cerca o esegui un comando...",
		"searchOrSupportedCommand": "Cerca o anteponi '$' e usa uno dei comandi supportati:",
		"typeCommand": "Scrivi e premi invio per eseguire.",
		"typeSearch": "Scrivi e premi invio per cercare.",
		"types": "Tipi",
		"video": "Video",
		"writeToSearch": "Scrivi qui per cercare"
	},
	"languages": {
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski"
	},
	"time": {
		"unit": "Unità di tempo",
		"seconds": "Secondi",
		"minutes": "Minuti",
		"hours": "Ore",
		"days": "Giorni"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/it.yaml
// module id = 287
// module chunks = 0